import { defineNuxtPlugin } from '#app'
import { ensureTenantLoaded } from '~/composables/useTenant'

// Resolve the tenant config as early as possible at app startup. The actual
// fetch + memoization lives in ensureTenantLoaded() so the auth middleware can
// await the very same promise (see middleware/auth.global.ts) and never act on
// tenant flags before the doc has loaded. In single-tenant mode this is a no-op
// (config comes from env via useState's default).
export default defineNuxtPlugin(async () => {
  await ensureTenantLoaded()
})
